import React, { forwardRef, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { SideDrawerRef } from '../../../SideDrawer/SideDrawer.component';
import { AnswerQuestionDrawer } from '../AnswerQuestionDrawer';
import { QuestionManagingDrawerCommonProps } from 'router/subrouters/DataRoom/models/QAndA';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import {
  APPROVAL_MODUS,
  QuestionReplyInitiatedEventProps,
} from 'models/MixpanelEvents';
import { richTextJsonToPlainText } from 'components/RichTextEditorField/utils';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

type WriteAnswerDrawerProps = QuestionManagingDrawerCommonProps;

const WriteAnswerDrawer: React.ForwardRefRenderFunction<
  SideDrawerRef,
  WriteAnswerDrawerProps
> = ({ question, onClose, onQuestionsUpdate, updateQuestion }, ref) => {
  const { isOwner } = useContext(DataRoomContext);

  const { t } = useTranslation();
  const getMixpanelProps = useGetMixpanelProps();

  const onQuestionSubmit = useCallback(
    async (answerContent: string) => {
      mixpanelService.questionReplyInitiated(
        getMixpanelProps({
          questionId: question._id,
          questionContent: richTextJsonToPlainText(question.content),
          answerContent: richTextJsonToPlainText(answerContent),
          approvalModus: APPROVAL_MODUS.MANUAL,
          isOwner,
        }) as QuestionReplyInitiatedEventProps,
      );

      await dataRoomApi.questionsAndAnswers.createAnswer(question._id, {
        answerContent,
      });
      onQuestionsUpdate?.();
    },
    [question, isOwner, getMixpanelProps, onQuestionsUpdate],
  );

  return (
    <AnswerQuestionDrawer
      ref={ref}
      title={t('answerThisQuestion')}
      question={question}
      onSubmit={onQuestionSubmit}
      onClose={onClose}
      updateQuestion={updateQuestion}
    />
  );
};

export default forwardRef(WriteAnswerDrawer);
